// Warn-only duplicate check for hand-typed invoice numbers. Invoice numbers
// are deliberately NOT unique (Henry's decision #4) — a clash is worth a
// second look, never a block, so every caller pairs this with an explicit
// "save anyway" step. A failed check must never stop a save.

import { formatInvoiceNumber } from '../../shared/format';
import { api } from './api';

interface InvoiceNumberHolder {
  id: string;
  invoice_number: string;
  label: string;
}

/** One-line warning, or null when the number is free (or unverifiable). */
export async function invoiceNumberWarning(
  invoiceNumber: string,
  excludeInvoiceId?: string,
): Promise<string | null> {
  const query = new URLSearchParams({ number: invoiceNumber });
  if (excludeInvoiceId) query.set('exclude', excludeInvoiceId);
  const result = await api<{ taken: boolean; holders: InvoiceNumberHolder[] }>(
    `/api/admin/finance/invoice-number-taken?${query.toString()}`,
  ).catch(() => null);
  if (!result?.taken || result.holders.length === 0) return null;
  const who = result.holders.map((holder) => holder.label).filter(Boolean);
  return (
    `${formatInvoiceNumber(invoiceNumber)} is already used by ` +
    `${who.length > 0 ? who.join(', ') : 'another invoice'}. Save anyway?`
  );
}
